import React from "react"
import { Section } from "../Components"
import Colors from "../res/styles/Colors"
import Lottie from "react-lottie-player"
import { wool, goat2, woolball, graph } from "../res/imgs/lotties"
import Counter from "../Atoms/Counter"
import { useTranslation } from "react-i18next"

function Cashmere() {
    const { t } = useTranslation()

    return (
        <>
            <Section
                bg={Colors.white}
                textColor={Colors.red}
                body={t("sections.cashmere.first")}
            >
                <Lottie loop={false} animationData={wool} play />
            </Section>
            <Section
                bg={Colors.red}
                textColor={Colors.peach}
                body={t("sections.cashmere.second")}
                left
            >
                <Lottie loop={true} animationData={goat2} play />
            </Section>
            <Section
                bg={Colors.white}
                textColor={Colors.red}
                body={t("sections.cashmere.third")}
            >
                <Counter />
            </Section>
            <Section
                bg={Colors.red}
                textColor={Colors.peach}
                body={t("sections.cashmere.fourth")}
                left
            >
                <Lottie loop={true} animationData={graph} play />
            </Section>
            <Section
                bg={Colors.white}
                textColor={Colors.red}
                body={t("sections.cashmere.fifth")}
            >
                <Lottie loop={true} animationData={woolball} play />
            </Section>
        </>
    )
}

export default Cashmere
